// extracted by mini-css-extract-plugin
export default {"successGreen":"#03c9a9","red":"#d64541"};